
const Menuitems = [
  {
    subHead: 'DONATIONS',
    content: [
      {
        title: "Overview",
        icon: "las la-home la-lg",
        href: "/overview",
        type: ['individual', 'organization'],
        role: [1, 2, 3, 4]
      },
      {
        title: "Donations",
        icon: "las la-gift la-lg",
        href: "/donations",
        type: ['individual', 'organization'],
        role: [1, 2, 4],
        group: [
          {
            title: "All App Donations",
            href: "/donations",
          },
          {
            title: "Donations by type",
            href: "/donations/types",
          },
          {
            title: "Anonymous",
            href: "/donations/anonymous",
          },
          {
            title: "Plate Collections",
            href: "/donations/plate",
          },
          {
            title: "Plate Collection Details",
            href: "/donations/platedetails",
          },
          {
            title: "Envelope Collections",
            href: "/donations/envelope",
          },
          {
            title: "Event Collections",
            href: "/donations/events",
          },
          {
            title: "Other Income",
            href: "/donations/otherincome",
          },
          // {
          //   title:"Events",
          //   href: "/donations/events",
          // },
        ],
      },
      {
        title: "Refunds",
        icon: "las la-wallet la-lg",
        href: "/refunds",
        type: ['individual', 'organization'],
        role: [1, 2, 4]
      },
      {
        title: "Donation Types",
        icon: "las la-gifts la-lg",
        href: "/donation-types",
        type: ['individual', 'organization'],
        role: [1, 2, 3, 4]
      },
      {
        title: "Event Types",
        icon: "las la-calendar la-lg",
        href: "/events",
        type: ['individual', 'organization'],
        role: [1, 2, 3, 4]
      },
      {
        title: "Gift Aid",
        icon: "las la-percentage la-lg",
        group: [
          {
            title: "Unclaimed App Donations",
            href: "/gift-aid/unclaimed-app-donations",
          },
          {
            title: "Unclaimed Collections",
            href: "/gift-aid/unclaimed-collections",
          },
          {
            title: "Unclaimed Plate Collections",
            href: "/gift-aid/unclaimed-plate-collections",
          },
          {
            title: "Unclaimed Other Income Collections",
            href: "/gift-aid/unclaimed-otherincome",
          },
          // {
          //   title:"Claimed",
          //   href: "/gift-aid/claimed",
          // },
          {
            title: "History",
            href: "/gift-aid/history",
          },
        ],
        href: "/admin/gift-aid",
        type: ['organization'],
        role: [1, 2, 4]
      },
      {
        title: "Donors",
        icon: "las la-user-friends la-lg",
        href: "/donors",
        type: ['individual', 'organization'],
        role: [1, 2, 3, 4]
      },
    ]
  },
  {
    subHead: 'ACCOUNT',
    content: [
      {
        title: "Stripe account",
        icon: "lab la-stripe-s la-lg",
        // href: "",
        icon_right: "las la-external-link-alt",
        action: 'ROUTE',
        type: ['individual', 'organization'],
        role: [1]
      },
      {
        title: "Settings",
        icon: "las la-cog la-lg",
        href: "/settings",
        type: ['individual', 'organization'],
        role: [1, 2, 3, 4]
      },
    ]
  },
  {
    subHead: 'UNIQUE ID',
    content: [
      {
        title: "id",
        icon_right: 'las la-copy la-lg',
        href: "",
        icon_color: '#2962FF',
        action: 'id',
        type: ['individual', 'organization'],
        role: [1, 2, 3, 4]
      },
      {
        title: "Get QR code",
        icon_right: 'las la-qrcode la-lg',
        // href: "/qr",
        action: 'QR',
        type: ['individual', 'organization'],
        role: [1, 2, 3, 4]
      },
    ]
  },
];

export default Menuitems;


